import { StyledTag } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useReadCustomerApi } from '../../api/use-read-customer-api';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentCardInfoProps as Props } from './types';

export const PaymentCardInfo = memo(
  ({ className, item, isPaymentMethod, paymentMethodId }: Props) => {
    const workspaceId = useWorkspace()?.id ?? '';
    const { data } = useReadCustomerApi(workspaceId);

    const isDefaultCard = paymentMethodId
      ? data?.method === paymentMethodId.id
      : false;

    return (
      <Styled.Wrapper
        className={classnames('PaymentCardInfo', className)}
        sx={SX.root({ isPaymentMethod, isDefaultCard })}
      >
        <Stack gap={isPaymentMethod ? 0 : 0.5}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            gap={isPaymentMethod ? 1.5 : 0}
          >
            <Typography
              variant={isPaymentMethod ? 'body2' : 'body4'}
              fontWeight={isPaymentMethod ? 700 : 500}
              color={isPaymentMethod ? 'grey.500' : 'grey.600'}
            >
              Master Card
            </Typography>
            <StyledTag
              variant={isPaymentMethod ? 'outlined' : 'filled'}
              color="default"
              label={`Expires ${item?.expMonth}/${item?.expYear
                .toString()
                .substring(2, 4)
                .trim()}`}
              size={isPaymentMethod ? 'xxsmall' : 'small'}
            />
          </Stack>
          <Typography
            variant={isPaymentMethod ? 'body5' : 'body4'}
            fontWeight={isPaymentMethod ? 500 : 400}
            color={isPaymentMethod ? 'grey.500' : 'grey.600'}
          >
            **** **** **** {item?.last4}
          </Typography>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

PaymentCardInfo.displayName = 'PaymentCardInfo';
